import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import { FileText, ScrollText } from 'lucide-react';
import DashboardBanner from '../../assets/banners/dashboard-banner.jpg';
import PolicyNavigatorImage from '../../assets/cardImages/policy-navigator.jpg';
import PolicyDocumentImage from '../../assets/cardImages/policy-documents.jpg';
import { IManagementAPIPolicySearchResponse } from '../../types/management-api/policy/search/response';
import { useApiClient } from '../../services/api-client';
import PolicySummary from '../Policy/Summary/Summary';
import { Loader } from '../Loader';
import PageHeader from '../Typography/PageHeader/PageHeader';
import CardGrid from '../Card/CardGrid';
import BannerImageComponent from '../BannerImage/BannerImage';

interface PageProps {
  children?: React.ReactNode;
}

const DashboardPage: React.FC<PageProps> = () => {
  const {
    isAuthenticated,
  } = useAuth0();

  const apiClient = useApiClient();
  const { isFetching, data } = useQuery<IManagementAPIPolicySearchResponse>({
    queryKey: ['policies'],
    queryFn: () => apiClient.get('/policy/search'),
    enabled: isAuthenticated,
  });

  return (
    <div className="container mx-auto px-8 md:px-0 mb-32">
      <BannerImageComponent imgSrc={DashboardBanner} />
      <PageHeader
        mainHeaderText="Dashboard"
        subHeaderText="Welcome to the Ingle Lewer International Insurance Admin Dashboard"
      />

      {isFetching ? (
        <Loader />
      ) : (
        <>
          <h2 className="text-md">Overview - Policy Summary</h2>
          <PolicySummary
            totalActiveItems={data?.meta.totalActiveItems}
            totalInActiveItems={data?.meta.totalInActiveItems}
            totalItems={data?.meta.totalItems}
            hasDirectLink
          />
          <CardGrid
            numberOfCols={3}
            cardData={[
              {
                header: 'Policy Navigator',
                cardImage: PolicyNavigatorImage,
                description:
                  'See policy listing, search & and re-send policy documents.',
                href: '/policies',
                isHrefExternal: false,
                icon: (
                  <ScrollText
                    className="h-16 w-16 p-2"
                    stroke="#fff"
                    strokeWidth={1}
                  />
                ),
              },
              {
                header: 'Documents',
                cardImage: PolicyDocumentImage,
                description: '',
                href: '/documents',
                isHrefExternal: false,
                icon: (
                  <FileText
                    className="h-16 w-16 p-2"
                    stroke="#ffffff"
                    strokeWidth={1}
                  />
                ),
              },
            ]}
          />
        </>
      )}
    </div>
  );
};

export default DashboardPage;
